import { useTranslation } from 'react-i18next';

import wemeetClient from '@utils/wemeetClient';
import { useAppSelector } from '@store/index';
import { LeaveReason, WeMeetClient } from '@tencent/wemeet-websdk-next';

import { Button } from '@tencent/tea-component';
import { openDialog } from '@component/dialog';

import './LeaveControl.css';
import { getSelfInfo } from '@store/user/user.slice';
import { gotoHomePage } from '@utils/navigate';

const LeaveControl = (props: { className?: string }) => {
  const { t } = useTranslation();
  const selfInfo = useAppSelector(getSelfInfo);
  const { className = '' } = props;
  const isHost = WeMeetClient.utils.isHost(selfInfo);
  /**
   *
   */
  const onClickLeaveButton = () => {
    // 打开弹窗
    openDialog({
      title: isHost ? t('结束会议') : t('离开会议'),
      content: isHost ? t('如果您不想结束会议，请选择离开会议，主持人会自动转交') : t('确定要离开此会议吗？'),

      btnConfigs: [
        {
          text: t('取消'),
        },
        isHost
          ? {
              text: t('结束会议'),
              type: 'primary',
              callback: () => {
                dissolveMeeting();
              },
            }
          : (undefined as any),
        {
          text: t('离开会议'),
          type: 'primary',
          callback: async () => {
            await leaveMeeting();
          },
        },
      ],
    });
  };

  const leaveMeeting = async () => {
    await wemeetClient.meetingCtrl.leaveMeeting(LeaveReason.SELF);

    gotoHomePage();
  };

  const dissolveMeeting = async () => {
    await wemeetClient.meetingCtrl.dissolveMeeting();

    gotoHomePage();
  };

  return (
    <div className={`leave-control__wrapper ${className}`}>
      <Button className="leave-control__btn" onClick={onClickLeaveButton} type="weak">
        {isHost ? t('结束会议') : t('离开会议')}
      </Button>
    </div>
  );
};

export default LeaveControl;
